import "./assets/fonts/Font.css";
import "./Common.css";
import { Outlet } from "react-router-dom";
import { MutationCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import "bootstrap/dist/css/bootstrap.min.css";
import { useSetAtom } from "jotai";
import { isLoading } from "./state/Spinner";
import './locales/i18n';
import { I18nextProvider } from 'react-i18next';
import i18n from './locales/i18n';
import { UserProvider } from "./util/userContext/UserContext";
import { HTML5Backend } from "react-dnd-html5-backend";
import { DndProvider } from "react-dnd";
import Spinner from "./components/common/Spinner";
import { CustomModal } from "./components/common/modal/CustomModal";
import React, { useEffect } from "react";
import { useAtomValue } from "jotai/index";
import {
    modal_state_atom1,
    modal_state_atom2,
    modal_state_atom3,
    modal_state_atom4,
    modal_state_atom5
} from "./components/common/modal/state";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            // This function receives a retryAttempt integer and the actual Error and returns the delay to apply before the next attempt in milliseconds.
            retryDelay: attempt => Math.min(attempt > 1 ? 2 ** attempt * 1000 : 1000, 30 * 1000),
            refetchOnWindowFocus: false, // default: true, If set to false, the query will not refetch on window focus.
        },
    },
    mutationCache: new MutationCache({
        onMutate: () => {
            queryClient.setQueryData(['__global_spinner'], true);
        },
        onSettled: () => {
            queryClient.setQueryData(['__global_spinner'], false);
        },
    }),
});

function App() {
    const isLoadingState = useAtomValue(isLoading);
    const modalState1 = useAtomValue(modal_state_atom1);
    const modalState2 = useAtomValue(modal_state_atom2);
    const modalState3 = useAtomValue(modal_state_atom3);
    const modalState4 = useAtomValue(modal_state_atom4);
    const modalState5 = useAtomValue(modal_state_atom5);

    const setLoading = useSetAtom(isLoading);

    useEffect(() => {
        const unsubscribe = queryClient.getQueryCache().subscribe(() => {
            const isLoading = queryClient.getQueryData(['__global_spinner']) ?? false;
            setLoading(isLoading);
        });
        return () => unsubscribe();
    }, []);

    return (
        <>
            <DndProvider backend={HTML5Backend}>
                <QueryClientProvider client={queryClient}>
                    <UserProvider>
                        <ReactQueryDevtools initialIsOpen={true} />
                        <I18nextProvider i18n={i18n}>
                        </I18nextProvider>

                        {isLoadingState && <Spinner />}

                        <CustomModal modalState={modalState1} />
                        <CustomModal modalState={modalState2} />
                        <CustomModal modalState={modalState3} />
                        <CustomModal modalState={modalState4} />
                        <CustomModal modalState={modalState5} />

                        <Outlet />
                    </UserProvider>
                </QueryClientProvider>
            </DndProvider>
        </>
    );
}

export default App;
